import { DefaultTheme } from 'styled-components';

const theme: DefaultTheme = {
  font_primary: process.env.REACT_APP_THEME_LIGHT_FONT_PRIMARY,
  font_secondary: process.env.REACT_APP_THEME_LIGHT_FONT_SECONDARY,
  font_success: process.env.REACT_APP_THEME_LIGHT_FONT_SUCCESS,
  font_danger: process.env.REACT_APP_THEME_LIGHT_FONT_DANGER,
  font_warning: process.env.REACT_APP_THEME_LIGHT_FONT_WARNING,
  font_info: process.env.REACT_APP_THEME_LIGHT_FONT_INFO,
  font_high: process.env.REACT_APP_THEME_LIGHT_FONT_HIGH,
  font_low: process.env.REACT_APP_THEME_LIGHT_FONT_LOW,

  button_primary: process.env.REACT_APP_THEME_LIGHT_BUTTON_PRIMARY,
  button_secondary: process.env.REACT_APP_THEME_LIGHT_BUTTON_SECONDARY,
  button_success: process.env.REACT_APP_THEME_LIGHT_BUTTON_SUCCESS,
  button_danger: process.env.REACT_APP_THEME_LIGHT_BUTTON_DANGER,
  button_warning: process.env.REACT_APP_THEME_LIGHT_BUTTON_WARNING,
  button_info: process.env.REACT_APP_THEME_LIGHT_BUTTON_INFO,
  button_high: process.env.REACT_APP_THEME_LIGHT_BUTTON_HIGH,
  button_low: process.env.REACT_APP_THEME_LIGHT_BUTTON_LOW,

  background_primary: process.env.REACT_APP_THEME_LIGHT_BACKGROUND_PRIMARY,
  background_secondary: process.env.REACT_APP_THEME_LIGHT_BACKGROUND_SECONDARY,
  background_success: process.env.REACT_APP_THEME_LIGHT_BACKGROUND_SUCCESS,
  background_danger: process.env.REACT_APP_THEME_LIGHT_BACKGROUND_DANGER,
  background_warning: process.env.REACT_APP_THEME_LIGHT_BACKGROUND_WARNING,
  background_info: process.env.REACT_APP_THEME_LIGHT_BACKGROUND_INFO,
  background_high: process.env.REACT_APP_THEME_LIGHT_BACKGROUND_HIGH,
  background_low: process.env.REACT_APP_THEME_LIGHT_BACKGROUND_LOW,
};

export default theme;
